import { render, staticRenderFns } from "./Video_signal.vue?vue&type=template&id=0455e85d&scoped=true"
import script from "./Video_signal.vue?vue&type=script&lang=js"
export * from "./Video_signal.vue?vue&type=script&lang=js"
import style0 from "./Video_signal.vue?vue&type=style&index=0&id=0455e85d&prod&scoped=true&lang=css"
import style1 from "./Video_signal.vue?vue&type=style&index=1&id=0455e85d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455e85d",
  null
  
)

export default component.exports